import React, { Component } from 'react';
import snare from './Assets/snare.wav'; 
import kick from './Assets/kick.wav'; 
import hihat from './Assets/hi-hat.wav'; 
import openhihat from './Assets/openhihat.wav'; 
import clap from './Assets/clap.wav'; 
import crash from './Assets/crash.wav'; 
import metal from './Assets/metal.wav'; 
import tom1 from './Assets/tom.wav'; 
import tom2 from './Assets/tom2.wav'; 
import cowbell from './Assets/cowbell.wav'; 
import stab from './Assets/stab.wav'; 
import science from './Assets/science.wav'; 

import './App.css';
import DrumPad from './DrumPad'; 

const sounds = [
  {id: 'snare', letter: 'A', src: snare},
  {id: 'kick', letter: 'F', src: kick},
  {id: 'hi-hat', letter: 'J', src: hihat},
  {id: 'open-hi-hat', letter: 'K', src: openhihat},
  {id: 'clap', letter: 'S', src: clap},
  {id: 'crash', letter: 'L', src: crash},
  {id: 'metal', letter: 'H', src: metal},
  {id: 'tom', letter: 'U', src: tom1},
  {id: 'tom2', letter: 'I', src: tom2},
  {id: 'cowbell', letter: 'O', src: cowbell},
  {id: 'effect1', letter: 'G', src: stab},
  {id: 'effect2', letter: 'V', src: science},
]

class App extends Component {



      render() {
      return (
        <div className="bg">
          <h1>Samplr</h1>
          <div className="App">
            {sounds.map(d => (
              <DrumPad id={d.id} letter={d.letter} displayed={d.displayed} src={d.src}/>
            ))}
          </div>
        </div>
      );
    }
}

export default App;
